import { META, HOURS } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#4A5638] text-[#F1ECDF]">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-[1.4fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-5xl text-[#F1ECDF]" style={{fontFamily:'"Caveat","Brush Script MT",cursive'}}>{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F1ECDF]/65 mt-2">{META.tag}</p>
          <p className="text-sm text-[#F1ECDF]/70 mt-5 leading-[1.7] max-w-md">Une trattoria de famille à deux pas du Cours Mirabeau. Thirty couverts. Cuisine du marché. Father in the kitchen, daughter on the floor.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E0C77A] mb-3">Hours</p>
          <table className="w-full text-sm">
            <tbody>
              {HOURS.map(([d, h]) => (<tr key={d} className="border-b border-[#F1ECDF]/15"><td className="py-2 text-[#F1ECDF]/85">{d}</td><td className="py-2 text-right text-[#F1ECDF]/65 font-mono text-[11px]">{h}</td></tr>))}
            </tbody>
          </table>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E0C77A] mb-3">À table</p>
          <p className="text-sm text-[#F1ECDF]/85 leading-relaxed">14 rue d'Italie<br />13100 Aix-en-Provence</p>
          <p className="font-mono text-[11px] text-[#F1ECDF]/55 mt-3">+33 4 42 555 0184</p>
          <button onClick={() => setPage('reserver')} className="mt-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#E0C77A] border-b border-[#E0C77A] pb-0.5 hover:text-[#F1ECDF]">Réserver →</button>
        </div>
      </div>
      <div className="border-t border-[#F1ECDF]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F1ECDF]/40">
        <span>© 2026 Savoria · Une cuisine, deux mains, trente couverts</span>
        <div className="flex gap-6"><a href="#" className="hover:text-[#E0C77A]">Instagram</a><a href="#" className="hover:text-[#E0C77A]">Press</a></div>
      </div>
    </footer>
  );
}
